var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessageSend = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8814 8.24498C17.9827 8.20163 18.0689 8.12953 18.1295 8.03762C18.1902 7.94571 18.2225 7.83803 18.2225 7.72792C18.2225 7.61782 18.1902 7.51014 18.1295 7.41823C18.0689 7.32632 17.9827 7.25422 17.8814 7.21087L1.68095 0.268028L1.68016 0.267233L1.17742 0.0508655C1.08216 0.00992986 0.977431 -0.00387703 0.874812 0.0109696C0.772194 0.0258163 0.675676 0.0687391 0.595921 0.134996C0.516165 0.201254 0.456276 0.288267 0.422868 0.386424C0.389461 0.484581 0.383835 0.590063 0.406612 0.691217L0.525932 1.22418L0.525136 1.22657L1.9705 7.72792L0.525136 14.2293L0.525136 14.2325L0.405816 14.7654C0.383404 14.8665 0.389305 14.9717 0.422868 15.0696C0.456432 15.1675 0.516357 15.2543 0.596048 15.3203C0.675738 15.3864 0.772104 15.4291 0.874538 15.4439C0.976972 15.4587 1.0815 15.445 1.17662 15.4042L17.8814 8.24498ZM14.9199 8.29032L2.99745 8.29032L3.09529 7.85043C3.11329 7.76975 3.11329 7.6861 3.09529 7.60542L2.99745 7.16553L14.9199 7.16553L16.2316 7.72792L14.9207 8.29111L14.9199 8.29032Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessageSend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/message-send.ed8b7a258c187ef7639d9c63f5008233.svg";